import type { GoodsBasicResponse } from 'shared/src/api/goodsService/getGoodsBasic/types';
import { isNil } from 'shared/src/utils';

/**
 * GoodsBasic에서 오늘출발 상품인지 여부를 판별 할수 있도록 하는 함수 <br/>
 * 함수로 분리한 이유는 query에 넣게되면, backend response로 착각될수 있는 소지가 있어, 별도로 util성으로 분리
 * @param goodsBasic
 */
export const isDeliveryTypeIsToday = (
  goodsBasic: GoodsBasicResponse['goods'] | undefined,
) => {
  if (isNil(goodsBasic)) return false;

  // shak은 18:00고정
  // 오늘출발은 마켓마다 다름
  return (
    goodsBasic.delivery_type_info.delivery_type === 'today' ||
    goodsBasic.delivery_type_info.delivery_type === 'shak'
    // &&
    // isNotNil(goodsBasic.market.today_delivery_order_deadline_time)
  );
};
